<template>
  <div
    :class="mode != 'preview' ? 'my-md-editor' : 'my-md-preview'"
    v-if="!refreshEnable"
  >
    <MarkdownEditor
      v-model="inputValue"
      @change="handleInputConfirm"
      @upload-image="handleUploadImage"
      :mode="mode"
      :placeholder="placeholder"
      :disabled-menus="[]"
      :left-toolbar="leftToolbar()"
      right-toolbar=""
    />
  </div>
</template>

<style lang="less">
.v-md-editor {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  width: 100%;
  background-color: #fff;
  box-shadow: none !important;
}

.v-md-editor__toolbar-left + .v-md-editor__toolbar-right {
  margin-left: 0px;
}

.my-md-editor {
  border-radius: 4px;
  border: 1px solid #dedede;
}

.my-md-preview {
  .v-md-editor-preview .github-markdown-body {
    padding: 0px;
  }
}
</style>

<script>
import { getUploadFileHandler } from '../common/libs/xui'
import { MarkdownEditor, getLeftToolBar, propsPlugin } from './md/index';

export default {
  components: {
    MarkdownEditor
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    mode: {
      type: String,
    },
    value: {
      type: String,
      default: ""
    },
    propValue: {
      type: String,
      default: ""
    },
    propList: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      inputValue: "",
      fileReader: new FileReader(),
      refreshEnable: false,
      propConfig: [],
    };
  },
  mounted() {
    this.initValue();
    this.initProps();
  },
  watch: {
    value() {
      this.initValue();
    },
    propList() {
      this.initProps();
    },
    propValue() {
      this.initProps();
    }
  },
  methods: {
    initValue() {
      if (this.value) {
        this.inputValue = this.value;
      } else {
        this.inputValue = "";
      }
      this.handleInputConfirm();
    },
    initProps() {
      this.refreshEnable = true;
      if (this.propList) {
        try {
          let valueModel = JSON.parse(this.propList);
          if (valueModel instanceof Array) {
            this.propConfig = valueModel;
          }
        } catch (e) {
          this.propConfig = [];
        }
      } else {
        this.propConfig = [];
      }
      this.$nextTick(() => {
        propsPlugin.setProps(this.propConfig, this.toAny(this.propValue, {}));
        this.refreshEnable = false;
      })
    },
    leftToolbar() {
      return getLeftToolBar();
    },
    handleUploadImage(event, insertImage, files) {
      getUploadFileHandler(files[0], 'image').then((resp => {
        insertImage({ url: resp, width: 'auto', height: 'auto' });
      }))
    },
    handleInputConfirm() {
      this.$emit("change", this.inputValue);
    },
  },
};
</script>